import EditorFileName from './EditorFileName';

export default EditorFileName;